import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareDecimalAttributePropertyValues =
    AttributePropertyValues
    & {
        currencySymbol?: string;
        precision: number;
        scale: number;
    };

export type ClientAwareDecimalAttributeProperties = {
    [name in keyof ClientAwareDecimalAttributePropertyValues]?: ClientAwareDecimalAttributePropertyValues[name];
};

export interface IClientAwareDecimalAttribute extends IAttribute, ClientAwareDecimalAttributeProperties
{
}

export class ClientAwareDecimalAttribute extends Attribute implements IClientAwareDecimalAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareDecimalAttribute";
    public static override className = "ClientAwareDecimalAttribute";

    public currencySymbol?: string;
    public precision?: number;
    public scale?: number;

    constructor(propertyValues?: Partial<ClientAwareDecimalAttributePropertyValues>)
    {
        super(propertyValues);

        this.currencySymbol = propertyValues?.currencySymbol;
        this.precision = propertyValues?.precision;
        this.scale = propertyValues?.scale;
    }
}